import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { Box, Card, CardContent, CardActions } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Divider, Button } from '@occc-app/design-system';
import { Product_Group_Key } from '@occc/graphql';

import { ProductGroupFormContent } from '../components/ProductGroupFormContent';
import { TotalAvailableRollbackEligibleFormItem } from '../components/TotalAvailableRollbackEligibleFormItem';
import { ProductGroupFormRenderCallback, ProductGroupFormValues } from '../types';
import { validate } from '../validation';

export interface UpdateProductGroupFormProps {
  readOnly: boolean;
  initialValues: ProductGroupFormValues;
  onSubmit: (values: ProductGroupFormValues) => void;
  children?: ProductGroupFormRenderCallback;
}

export const UpdateProductGroupForm: React.FC<UpdateProductGroupFormProps> = ({
  readOnly,
  initialValues,
  onSubmit,
}) => {
  const navigate = useNavigate();

  const renderForm = React.useCallback(
    ({ handleSubmit, values }: FormRenderProps<ProductGroupFormValues>) => (
      <form onSubmit={handleSubmit}>
        <Card>
          <CardContent>
            <ProductGroupFormContent
              readOnly={readOnly}
              values={values}
              title='Edit Product Group'
              disabledGroupTypeChange
            />
          </CardContent>
          <Divider />
          {values.key === Product_Group_Key.FuelGradeId ? (
            <>
              <Box m={3}>
                <TotalAvailableRollbackEligibleFormItem
                  showTARConfigurationFields={!!values.userSelectable}
                />
              </Box>
              <Divider />
            </>
          ) : null}
          <CardActions>
            <Button role='button' onClick={() => navigate(-1)}>
              cancel
            </Button>
            <Button variant='contained' color='primary' onClick={handleSubmit}>
              Save
            </Button>
          </CardActions>
        </Card>
      </form>
    ),
    [readOnly, navigate],
  );

  return (
    <Form<ProductGroupFormValues>
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={renderForm}
      validate={validate}
    />
  );
};
